import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { brandEnum, orgEnum, sysEnum } from '@/views/customer/commonEnum/dataConfig'
import { customerList, getListBySensitize } from '@/api/customer'
import type { CustomerManageParams, CustomerManageListItem } from '@/typings/api/customer'
import dayjs from 'dayjs'


const __default__ = { name: 'DcCosCustomerManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const tableRef = ref()
const queryForm = reactive<CustomerManageParams>({})
queryForm.createTimeStart = dayjs().subtract(30, 'day').format('YYYY/MM/DD 00:00:00')
queryForm.createTimeEnd = dayjs().format('YYYY/MM/DD 23:59:59')
const columns = computed(() => [
  { title: '集团客户代码', dataIndex: 'cosCenterCode' },
  { title: '集团客户名称', dataIndex: 'cosCenterName' },
  { title: '所属品牌', dataIndex: 'brand', dicData: brandEnum },
  { title: '签约主体', dataIndex: 'cusContractSubject' },
  { title: '所属组织', dataIndex: 'appId', dicData: orgEnum },
  { title: '业务系统', dataIndex: 'sys', dicData: sysEnum },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '客户代码', dataIndex: 'customerCode' },
  { title: '增值税登记号', dataIndex: 'addedValueNo' },
  { title: '法人姓名', dataIndex: 'legalPerson', cosType: 'mask' },
  { title: '国家/地区', dataIndex: 'countryName' },
  { title: '省/地区', dataIndex: 'provinceName' },
  { title: '城市', dataIndex: 'cityName' },
  { title: '地址', dataIndex: 'address' },
  { title: '联系人', dataIndex: 'contactName', cosType: 'mask' },
  { title: '电话', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: 'E-mail', dataIndex: 'contactEmail', cosType: 'mask' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 100, fixed: 'right' }
])
const getList = (queryForm: CustomerManageParams, callBack: (res: any) => void) => {
  customerList(queryForm).then((res) => {
    if (res.data && res.data.items && res.data.items.length) {
      res.data.items.forEach((item: CustomerManageListItem) => {
        if (item.appId) {
          item.appId = (item.appId as string).split(',')
        }
      })
    }
    callBack(res)
  })
}
const showMask = (record: CustomerManageListItem, callBack: (res: any) => void) => {
  getListBySensitize({
    cosCenterCode: record.cosCenterCode
  }).then((res) => {
    callBack(res.data)
  })
}

// 新增编辑函数
const goToDetailsList = (masterCosCenterCode: string) => {
  // 清缓存
  localStorage.setItem('dc-cos-lbu-exclude-keep-alive', masterCosCenterCode)
  router.push({
    path: '/customer/customerAggregation',
    query: {
      masterCosCenterCode
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[14] || (_cache[14] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosCustomerManage"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "集团客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosCenterCode,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.cosCenterCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "集团客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosCenterName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.cosCenterName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "所属品牌" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.brand,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.brand) = $event)),
                        options: _unref(brandEnum),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "签约主体" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cusContractSubject,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.cusContractSubject) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "所属组织" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.appId,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.appId) = $event)),
                        options: _unref(orgEnum),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "业务系统" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.sys,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.sys) = $event)),
                        options: _unref(sysEnum),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerCode,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customerCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "增值税登记号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.addedValueNo,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.addedValueNo) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "法人姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.legalPerson,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.legalPerson) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "联系人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactName,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.contactName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "电话" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactMobile,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.contactMobile) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "E-mail" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactEmail,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.contactEmail) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.createTimeStart,
                        "onUpdate:startTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.createTimeStart) = $event)),
                        endTime: queryForm.createTimeEnd,
                        "onUpdate:endTime": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.createTimeEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (goToDetailsList(record.masterCosCenterCode))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("客户明细")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_permission, 'customer_detail_btn']
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})